import React from "react";
import PropTypes from "prop-types";
import { handleType, emailBuilder } from "../helpers";
import {
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    EmailShareButton
} from "react-share";

class ShareMob extends React.Component {
    render() {
        const {
            resource,
            closeModal,
        } = this.props;

        const {
            description,
            src,
            thumbnail,
            title,
            type,
            emailSubject,
            emailBody,
            twitter,
            linkedin,
            facebook,
        } = resource;

        const typeFix = handleType(type);

        const messages = emailBuilder(emailBody);

        return (
            <section className="mob-modal">
                <header className="mob-modal__header container wrapper">
                    <a className="icon header__logo-link" href="/">
                        <img
                            src="/img/logo.svg"
                            className="header__logo"
                            alt="Chubb Logo"
                        />
                    </a>
                    <button
                        className="mob-modal__trig"
                        onClick={closeModal}
                    >
                        <i className="fal fa-times" />
                    </button>
                </header>
                <section className="mob-modal__hero wrapper">
                    <div className="hero__wrap">
                        <h1 className="hero__title">Share {typeFix}</h1>
                    </div>
                    <section className={`resource__content is-${type}`}>
                        <article className="resource-share">
                            <figure
                                className="resources-share__fig"
                                style={{ backgroundImage: `url(${thumbnail})` }}
                            />
                            <aside className="resources-share__content">
                                <h3 className="resources__title">{title}</h3>
                                <p className="resources__copy">{description}</p>
                            </aside>
                        </article>
                        <section className="filter__btn-wrap modal-share-btns">
                            <FacebookShareButton
                                url={src}
                                quote={`${facebook}`}
                            >
                                <button
                                    className="modal-btn modal-btn--fb"
                                    data-social-bookmark={`Facebook`}
                                >
                                    Facebook
                                </button>
                            </FacebookShareButton>
                            <LinkedinShareButton
                                url={src}
                                title={title}
                                description={`${linkedin}`}
                            >
                                <button
                                    className="modal-btn modal-btn--li"
                                    data-social-bookmark={`LinkedIn`}
                                >
                                    Linkedin
                                </button>
                            </LinkedinShareButton>
                            <EmailShareButton
                                url={src}
                                subject={`${emailSubject}`}
                                body={`${messages}\n\n${src}`}
                            >
                                <button
                                    className="modal-btn modal-btn--email"
                                    data-social-bookmark={`Email`}
                                >
                                    Email
                                </button>
                            </EmailShareButton>
                            <TwitterShareButton url={src} title={`${twitter}`}>
                                <button
                                    className="modal-btn modal-btn--twit"
                                    data-social-bookmark={`Twitter`}
                                >
                                    Twitter
                                </button>
                            </TwitterShareButton>
                        </section>
                    </section>
                </section>
            </section>
        );
    }
}

export default ShareMob;



// WEBPACK FOOTER //
// ./src/components/ShareMob.js